import { useEffect, useState } from "react";

type timeKeyType = "DAY" | "WEEK" | "MONTH" | "YEAR";
interface HistoricalPriceType {
  min_usdt_price: string;
  max_usdt_price: string;
  min_irr_price: string;
  max_irr_price: string;
  interval_type: timeKeyType;
}
const timeKeys = ["DAY", "WEEK", "MONTH", "YEAR"];

export const useHistoricalPrice = (
  historicalPriceList: HistoricalPriceType[],
) => {
  const [activeTime, setActiveTime] = useState(0);
  const [coinDataBaseOnTime, setCoinDataBaseOnTime] =
    useState<HistoricalPriceType | null>(null);

  useEffect(() => {
    setCoinDataBaseOnTime(historicalPriceList?.[0]);
    setActiveTime(timeKeys.indexOf(historicalPriceList?.[0]?.interval_type));
  }, []);

  const changeActiveTime = (index: number) => {
    setActiveTime(index);
    let selectedTime = timeKeys[index];
    for (let i = 0; i < historicalPriceList?.length; i++) {
      if (historicalPriceList?.[i].interval_type === selectedTime) {
        setCoinDataBaseOnTime(historicalPriceList?.[i]);
      }
    }
  };

  return {
    activeTime,
    coinDataBaseOnTime,
    changeActiveTime,
  };
};
